<template>
  <el-container>
      <el-header style="padding:15px;">
        <el-container>
          <el-aside width="">
            
            <el-page-header @back="goBack" content="">
            </el-page-header>
          </el-aside>
          <el-main style="margin:0px;padding:0px;margin-top:0px;overflow:hidden;">
            <el-row type="flex" align="middle" :gutter="20" v-if="this.subjectInfo.length != 0">
              <el-col :span="1">
                <span>
                  <el-avatar slot="reference" :src="this.subjectInfo.headimgurl" :size="30">
                    {{this.subjectInfo.subjectname.substring(this.subjectInfo.subjectname.length-2,4)}}
                  </el-avatar>
                </span>
              </el-col>
              <el-col :span="22" >
                {{this.subjectInfo.subjectnumber}} {{this.subjectInfo.subjectname}} {{this.subjectInfo.initials}} 
                <span v-if="this.subjectInfo.sex == 'M'">
                  男
                </span>
                <span v-else-if="this.subjectInfo.sex == 'F'">
                  女
                </span>
                <span v-if="this.subjectInfo.dob||'' != ''"> 
                  {{this.subjectInfo.dob.split(' ')[0]}}
                  ({{this.global_getage(this.subjectInfo.dob)}}岁)

                </span>
          
                <el-link v-if="this.subjectInfo.weixinuserid ||'' != ''"
                  icon="el-icon-chat-dot-round" 
                  @click.stop="showWeixinTalk(subjectInfo)" 
                  :underline="false" 
                  style="font-size:20px;padding-left:8px;padding-right:8px"></el-link>

                <el-link icon="el-icon-edit" 
                @click.stop="$router.push({name:'subject-new',query:{id:subjectInfo.subjectid}});" 
                target="_blank" :underline="false" 
                style="font-size:20px;padding-right:8px"></el-link>
                <el-link icon="el-icon-notebook-2" 
                @click.stop="$router.push({name:'forminput',query:{id:subjectInfo.subjectid}});" 
                :underline="false" 
                style="font-size:20px;padding-right:8px"></el-link>


                  <!-- 标签处理 -->
                   <el-popover
                    v-model="taginputvisible"
                    placement="bottom"
                    width="400"
                    trigger="click">
                    <div>
                      <!-- <el-divider content-position="left">已选标签</el-divider> -->
                      <i class="fa fa-tags"></i>已选标签
                      <div style="border:0px solid #aabbcc;padding:8px;">
                        <span v-if="(subjectInfo.category || []).length !=0">
                          <el-tag 
                            style="margin-left:3px;"
                            
                            size="mini"  
                            v-for="(item,index) in subjectInfo.category.split(',')" 
                            closable
                            :disable-transitions="false"
                            @close="handleTagClose(item)"
                            :key="index">{{item}}
                          </el-tag>
                        </span>
                        
                        <div style="padding-top:8px;padding-right:8px;">
                          <el-input
                          v-model="taginputvalue"
                          size="media"
                          placeholder="标入标签，回车确认"
                          clearable
                          @keyup.enter.native="submitTag"
                          />
                        </div>
                      </div>
                      <br>
                      <i class="fa fa-tags"></i>我的标签库
                      <div style="border:0px solid #aabbcc;padding:0px;">
                        <!-- <el-divider content-position="left">我的标签库</el-divider> -->
                        <el-tag
                          :key="index"
                          v-for="(tag,index) in tagtemplates.mytags.filter(data=>!this.taginputvalue
                            || data.tagname.toLowerCase().includes(this.taginputvalue.toLowerCase())
                            )"
                          :disable-transitions="false"
                          @click="selectTag(tag.tagname)"
                          style="cursor:pointer;margin:3px;"
                          effect="plain"
                        >
                          {{tag.tagname}}{{tag.num>0?'('+tag.num+')':''}}
                        </el-tag>
                      </div>
                      <br>
                      <i class="fa fa-tags"></i>ICD-11
                        <div style="border:0px solid #aabbcc;padding:0px;">
                        <!-- <el-divider content-position="left">ICD-11</el-divider> -->
                        <!-- <div style="height:300px;">
                        <el-tag
                          v-if="taginputvalue !== ''"
                          :key="index"
                          v-for="(tag,index) in tagtemplates.icd11.filter(data=>!this.taginputvalue
                            || data.tagname.toLowerCase().includes(this.taginputvalue.toLowerCase())
                            )"
                          :disable-transitions="false"
                          @click="selectTag(tag.tagname)"
                          style="cursor:pointer;margin:3px;"
                          effect="plain"
                        >
                          {{tag.tagname}}
                        </el-tag>
                        </div> -->
                        <el-table 
                          :data="tagtemplates.icd11.filter(data=> this.taginputvalue &&
                                                      data.tagname.toLowerCase().includes(this.taginputvalue.toLowerCase())
                                                      )" 
                          :show-header="true" 
                          max-height="310px"
                          @row-click="selectTagTable">
                            <el-table-column prop="name" label="疾病名称">
                              <template slot-scope="scope">
                                {{scope.row.tagname}}
                              </template>
                            </el-table-column>
                            <el-table-column prop="name" label="编码" width="80px;">
                              <template slot-scope="scope">
                                {{scope.row.tagid}}
                              </template>
                            </el-table-column>
                        </el-table>
                      </div>
                    </div>

                    <el-link slot="reference" class="el-icon-circle-plus-outline"
                    style="font-size:20px;" :underline="false">
                    </el-link>
                    <!-- <i slot="reference" class='el-icon-plus' style="font-size:16px;"></i> -->
                  </el-popover>
                  

                  <span v-if="(subjectInfo.category || []).length !=0">
                    <el-tag 
                      style="margin-left:3px;"
                      
                      size="mini"  
                      v-for="(item,index) in subjectInfo.category.split(',')" 
                      
                      :disable-transitions="false"
                      
                      :key="index">{{item}}
                    </el-tag>
                  </span>
              </el-col>


            </el-row>
 
          </el-main>
          <el-aside width="250px">
          </el-aside>
        </el-container>


       
      </el-header>
      <el-main>
        <router-view :key="$route.fullPath"></router-view>


         <el-drawer
              title="聊天框"
              size = "50%"
              :visible.sync="talk.drawer"
              :with-header="false">
              
                    <template>
                      <el-row style="text-align:center;height:30px;line-height:30px;padding-left:8px;">
                        <el-col>{{this.talk.to}}</el-col>
                      </el-row>

                      <div style=" overflow: hidden;">
                        <el-row>
                          <el-col :span="24" :offset="0">
                            <div
                              id="dataShow"
                              onmouseover="this.style.overflow='overlay'"
                              onmouseout="this.style.overflow='hidden'"
                              class="dataShow"
                            >
                              <div
                                v-for="(item,index) in computedTalkList"
                                :key="index"
                                style="background-color: #f5f5f5; padding:8px;"
                              >
                              <el-row style="text-align:center;padding:3px;">
                                <el-col :span="24" :offset="0">
                                  <span style="font-size:8px;color:#fff;background-color:#dadada;">{{item.talktime}}</span><br>
                                </el-col>
                              </el-row>
                                <el-row v-if="item.sendertype =='PI'">
                                  <el-col :span="20" :offset="2">
                                    <!-- <span style="float:right;font-size:8px;color:#fff;background-color:#dadada;">{{item.time}}</span><br> -->
                                    <span v-if="item.messagetype == 'image'" class="aa-image">
                                      <el-image
                                      style="width: 150px;"
                                      :src='"http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype' 
                                      fit="fill"
                                      :preview-src-list='["http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype]'
                                      ></el-image>
                                    </span>
                                    <span v-else-if="item.messagetype=='voice'" class="aa">
                                      (暂无法在线播放)<i class="fa fa-wifi fa-rotate-270"></i>
                                    </span>
                                    <span v-else class="aa">
                                      {{ item.message }}
                                    </span>
                                  </el-col>
                                  <el-col :span="1" >
                                    <span> 
                                        <!-- <el-avatar slot="reference" icon="el-icon-user-solid" :size="30"></el-avatar> -->
                                        <el-avatar slot="reference" shape="square" :src="item.piheadimgurl" :size="40"></el-avatar>
                                    </span>
                                  </el-col>
                                </el-row>
                              
                                <el-row v-if="item.sendertype =='SUB'">
                                  <el-col :span="1">
                                    <span>       
                                        <el-avatar slot="reference" shape="square" :src="item.subheadimgurl"  :size="40"></el-avatar>
                                    </span>
                                  </el-col>
                                  <el-col :span="20">
                                    <!-- <span style="margin-left: 12px;font-size:8px;color:#fff;background-color:#dadada;">{{item.time}}</span><br> -->
                                    <span v-if="item.messagetype == 'image'" class="bb-image">
                                      <el-image
                                      style="width: 150px;"
                                      :src='"http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype' 
                                      fit="fill"
                                      :preview-src-list='["http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype]'
                                      ></el-image>
                                    </span>
                                    <span v-else-if="item.messagetype=='voice'" class="bb">
                                      <i class="fa fa-wifi fa-rotate-90"></i>(暂无法在线播放)
                                    </span>
                                    <span v-else class="bb">
                                      {{ item.message }}
                                    </span>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>


                      <div v-if="subjectInfo.weixinstatus =='online'">
                        <!-- <el-divider/> -->
                        <el-row>
                          <el-col :span="22" :offset="1">
                            <el-input
                              v-model="talk.message"
                              type="textarea"
                              autofocus
                              clearable
                              maxlength="100"
                              show-word-limit
                              :autosize="{minRows:3,maxRows:6}"
                              resize="none"
                              placeholder="在这里输入..."
                              @keyup.enter.native="sendMessage"
                            />
                          </el-col>
                        
                        </el-row>
                        <el-row style="margin: 4px 20px">
                          <el-button
                            style="border:0px solid #000;float:right;"
                            onmouseover="this.style.backgroundColor='#129611';this.style.color='#f5f5f5'"
                            onmouseout="this.style.backgroundColor='#f5f5f5';this.style.color='#606060'"
                            @click="sendMessage"
                          >
                            发送
                          </el-button>
                        </el-row>
                      </div>
                    </template>


            </el-drawer>
      </el-main>
    </el-container>
</template>

<script>
export default {
    data() {
      return {
        subjectid:this.$route.query.id,
        subjectInfo:[],

        //聊天框
        talk:{
          drawer:false,
          datalist: [],
          visible: false,
          to:'',
          message:'',
          subjectid:'',
          wxuserid:'',
        },

        taginputvalue:"",
        taginputvisible:false,
        tagtemplates:{
          mytags:[],
          icd11:[],
        },
      }
    },
    computed:{
      computedTalkList(){
        let arryData =[];
        let lasttime = "";
        this.talk.datalist.forEach(element => {
          if(lasttime == "")
          { 
            element.talktime = this.$moment(element.createddate).format("YYYY年MM月DD日 HH:mm:ss");
          }
          else if(this.$moment(element.createddate).diff(this.$moment(lasttime), 'minutes') !=0)
          {   
            element.talktime = this.$moment(element.createddate).format("YYYY年MM月DD日 HH:mm:ss");
          }

          lasttime = element.createddate;

          arryData.push(element);
        });

        return arryData;
      }
    },
    created() {
      
    },
    watch:{
      taginputvisible(val){
        if(val){
          if(this.tagtemplates.icd11.length == 0){
            this.getTagList();
            this.getTagTemplateList();
          }
        }
      }
    },
    mounted() {
      this.getSubjectInfo(this.subjectid);
      
    },
    methods: {
      goBack() {
        this.$router.push({ name: 'home-subject', params: { }})
      },
      getSubjectInfo(subjectid){
        if(!subjectid) return;
        this.$http.get('subject/info',
        {
          params:{subjectid:this.subjectid}
        })
        .then((res) => { 
          this.subjectInfo = res.data.info;
        });
      },

      //聊天框--start
      showWeixinTalk(row){
        this.talk.to = row.subjectnumber + ' ' + row.subjectname;
        this.talk.wxuserid = row.weixinuserid;
        this.talk.subjectid = row.subjectid;
        this.talk.drawer = true;

        this.getWeixinTalk();
      },
      getWeixinTalk(){
        this.$http.get('weixinuser/getweixinusertalk',
          {
            params:{
                      subjectid:this.talk.subjectid,
                   }
          }).then(res=>{
          if(!res) return;
            this.talk.datalist = res.data.list;
            this.scrollToBottom();
        });
      },
      clearBr(key) {
        key = key.replace(/<\/?.+?>/g, '')
        key = key.replace(/[\r\n]/g, '')
        return key
      },
      sendMessage(){
        this.talk.message = this.clearBr(this.talk.message)
        if (this.talk.message === '' || this.talk.message === undefined || this.talk.message === null) {
          this.$message.error('不能发送空白消息')
        }
        else{

          this.$http.post('weixinuser/sendweixinmessage',
            { 
              'message':this.talk.message,
              //'wxuserid':this.talk.wxuserid,
              'subjectid':this.talk.subjectid,
            })
          .then((res)=>{
            if(!res) return;
            
            this.talk.message = '';
            this.getWeixinTalk();

          });
        }

      },
      // 滚动到底部
      scrollToBottom() {
        this.$nextTick(() => {
          const div = document.getElementById('dataShow')
          div.scrollTop = div.scrollHeight
        })
      },
      //聊天框--end


      //标签
      handleTagClose(tag){
        
        let arrycategory = this.subjectInfo.category.split(',');        
        arrycategory.splice(arrycategory.indexOf(tag), 1);
        this.subjectInfo.category= arrycategory.join(",");

        //删除
        this.saveTag(this.subjectid,this.subjectInfo.category);

      },
      submitTag(){
        
        let tagname = this.taginputvalue;
        if(tagname){
          if(this.appendTag(tagname)){

            //增加
            this.saveTag(this.subjectid,this.subjectInfo.category);

            this.taginputvalue = "";
            this.taginputvisible = false;
          }
        }
      },
      saveTag(subjectid,tags){
          this.$http.post('subject/edittag',{subjectid:subjectid,category:tags})
          .then((res)=>{
            this.getTagList();
          });
      },
      selectTag(tagname){
        this.taginputvalue = tagname;
        this.submitTag();
      },
      selectTagTable(row, col, evt) {
        
        this.selectTag(row.tagname);
      },
      appendTag(tagname){
        let arryTags=[];
        if(this.subjectInfo.category){
          arryTags = this.subjectInfo.category.split(','); 
          if(arryTags.indexOf(tagname) !=-1){
            //已存在
            return false;
          }
        }
        arryTags.push(tagname);
        this.subjectInfo.category = arryTags.join(",");
        return true;
      },

      getTagList(){
        this.$http.get('tag/list',{params:{tagtype:'SUBJECT',minnum:1}}).then((res)=>{
          if(!res) return;
          this.tagtemplates.mytags = res.data.list;
        })
      },
      getTagTemplateList(){
        this.$http.get('tag/templatelist',{params:{tagtype:'icd11'}}).then((res)=>{
          if(!res) return;
          this.tagtemplates.icd11 = res.data.list;
        })
      },
    }
  };
</script>

<style lang="less" scoped>

  
</style>